import React, { useState, useEffect, useRef } from 'react';
import { Button, Box } from '@material-ui/core';
import AutorenewIcon from '@material-ui/icons/Autorenew';

const AutoRefreshToggle = ({ storageKey = '', onInterval }) => {
  const [enabled, setEnabled] = useState(false);
  const intervalRef = useRef(null);
  const countdownRef = useRef(null);
  const onIntervalRef = useRef(onInterval);
  const shouldShow = sessionStorage.getItem(storageKey) === '1';
  const [countdown, setCountdown] = useState(15);

  useEffect(() => {
    onIntervalRef.current = onInterval;
  }, [onInterval]);

  useEffect(() => {
    const saved = sessionStorage.getItem(`${storageKey}_enabled`);
    if (saved === '1') setEnabled(true);
  }, [storageKey]);

  useEffect(() => {
    clearInterval(intervalRef.current);
    clearInterval(countdownRef.current);

    if (enabled) {
      if (typeof onIntervalRef.current === 'function') onIntervalRef.current();

      let counter = 15;
      setCountdown(counter);

      countdownRef.current = setInterval(() => {
        counter -= 1;
        if (counter <= 0) counter = 15;
        setCountdown(counter);
      }, 1000);

      intervalRef.current = setInterval(() => {
        if (typeof onIntervalRef.current === 'function') onIntervalRef.current();
        counter = 15;
        setCountdown(counter);
      }, 15000);

      sessionStorage.setItem(`${storageKey}_enabled`, '1');
    } else {
      sessionStorage.setItem(`${storageKey}_enabled`, '0');
      setCountdown(15);
    }

    return () => {
      clearInterval(intervalRef.current);
      clearInterval(countdownRef.current);
    };
  }, [enabled, storageKey]);

  if (!shouldShow || !storageKey) return null;

  const handleClick = () => setEnabled((prev) => !prev);

  return (
    <Button
      onClick={handleClick}
      className={
        enabled
          ? 'buttonStyle addBorderRadius primaryBgColorLight primaryColor'
          : 'addBorderRadius buttonStyle'
      }
      title="Auto Refresh"
      variant="contained"
      disableElevation
      size="small"
      style={{
        color: enabled ? '#18CC69' : '#334D6E',
        position: 'relative',
        minWidth: 65,
        transition: 'all 0.3s ease',
        overflow: 'hidden',
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <AutorenewIcon className={enabled ? 'rotateIcon' : ''} style={{fontSize: 30}}/>
        {enabled && (
          <Box
            style={{
              position: 'absolute',
              fontSize: 10,
              fontWeight: 'normal',
              top: 8,
              color: '#18CC69',
            }}
          >
            {countdown}
          </Box>
        )}
      </Box>
    </Button>
  );
};

export default AutoRefreshToggle;
